import Vue from 'vue';
import debounce from 'debounce';

interface IsSmallMethods {
	checkSize(): void,
}

interface IsSmallData {
	smallSize: number,
	isSmall: boolean,
}

export default Vue.extend<IsSmallData, IsSmallMethods, {}, {}>({
	data(){
		return {
			isSmall: window.innerWidth <= 768,
			smallSize: 768
		}
	},
	created(){
		window.addEventListener('resize', debounce(this.checkSize.bind(this), 250));
	},
	methods: {
		checkSize(){
			this.isSmall = window.innerWidth <= this.smallSize
		}
	}
})